module.exports = __webpack_public_path__ + "img/img_modD.e754c865.png";